var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 210,
    height: 46,
    viewBox: "0 0 210 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 210,
    height: 46,
    transform: "translate(856 37)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(-856 -37)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-2",
    "data-name": "logo",
    transform: "translate(585.618 -64.948)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M288.811,128.209H295.1v-4.073h-6.11V111.743h6.11v-4.073H280.112l.095-1.476h-4.349l-.742,13.316h4.444l.371-7.767h4.436v12.392h-9.061v4.073h8.509l-9.432,16.236h4.9l6.749-11.145,5.091,11.145h5.083l-7.4-16.236Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M298.985,143.514l16.276-36.206H298.985Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M342.836,140.419l-8.88-5.738v-5.731h-4.626v5.92l-2.77,9.575H331l1.855-5.509,8.509,5.509h24.793l1.658-4.026H349.869v-7.033H365.04v-4.065H349.869V123.4h15.542l-37-16.465V123.4h16.836v17.018Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M452.486,130.239h3.336v2.643l19.8.171v2.978l-13.714-.355,12.42,6.159-2.865,3.744-15.638-9.548v9.851h-3.336v-9.972l-16.327,9.433-2.742-2.91,13.59-6.532-14.493.129V132.7l19.929.182Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M453.233,104.948l-1.665,5.367h-.742l-2.589-.189.189,2.589v14.437l-2.6-5.557-2.505.925,1.125,3.171-5.583.474,9.371-11.043-3.513-2.589-2.519,3.545-4.025.479,6.916-9.416-3.289-1.543L434.03,116.77l.891,3.349,5.57-1.232-6.683,7.333,1.484,3.521,10.057-1.618.866,1.734,3.135-1.04,10.9-.07.015-1.595,1.3,2.218,9.239-1.244,1.117,1.986,3.149-1.295-3.52-7.033-2.771,1.113,1.1,2.64-1.661.131-4.255.371,5.549-7.215L473.438,114l-2.987-1.789-3.063,4.408-3.98.17,5.367-8.138.734-.924.371-.371-4.065-1.665-5.549,10.545v-3.7l.363-2.407-2.77.189H455.27l2.036-4.444-4.073-.923Zm7.033,13.687.734,1.3,4.912-.92-5.646,6.651Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M403.035,108.438l-.19-.182-2.218-2.551-3.331.455,2.037,2.827,3.7-.549Zm-20.349,4.286,6.728-6.258-4.139-.672-6.844,6.93,1.105,1.641,5.849-.188-5.876,4.535,1.14,1.121,6.917-.652-9.1,6.291,3.083,1.389,12.973-9.853-3.45-1.606-2.388,2.381-4.155.316L393,110.79l-3.664-.983-2.818,2.814-3.836.1Zm34.406-3.251c-.812.778-2.409,3.6-3.512,5.071q4.061,2.461,4.065,5.744c-.119,1.034-1.973,1.458-5.549,1.276a5.533,5.533,0,0,1,1.484,2.189q4.44-.274,5.92-1.1a2.72,2.72,0,0,0,1.665-2.734q.178-2.734-4.254-5.467l4.988-7.382h-13.51l.076,18.712,3.5.723L412,109.473Zm-22.529-.4h11.431v9.205l-4.443-.089h-4.065v4.223l4.422-1.341c-.245-.366-.476-.483-1.463-1.152l2.961-.455q2.77,2.556,2.77,2.552a18.908,18.908,0,0,1,1.484,1.369l-3.15.637c-.741-1.155-1.168-1.641-1.294-1.458q-5.92,1.819-8.327,2.734c-.616-.486-1.3-.972-2.029-1.459l1.666-1.092.037-13.674Zm2.923,1.459v2.551h5.549v-2.551Zm0,4.168v2.213h5.549V114.7Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M419.863,127.924l-19.8-3.847-19.788,4v2.783l1.476-.314V143.2l-1.847.082v2.6l19.8-.806v-2.6l-13.651.478v-2.8h31.964v-9.928l1.847.321v-2.626Zm-35.33,1.82,15.533-2.883,16.1,2.883H402.845l-.553-1.278h-4.9l.552,1.278Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M401.179,143.518l18.131,2.364v-2.364l-3.142-.4,1.847-1.92h-5.367l-1.105,1.121-10.364-1.442v2.644Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M413.97,135.679v2.795H386.052v-2.795Zm0-4.164v2.795H386.052v-2.795Z",
    fill: "#98cb33",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M315.261,107.307l-16.276,36.206h16.276Z",
    fill: "#ffcb00",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M328.407,106.936h37V123.4Z",
    fill: "#00a1e8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 5.367,
    height: 5.367,
    transform: "translate(451.749 120.671)",
    fill: "#cb3366"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 5.367,
    height: 4.997,
    transform: "translate(451.749 113.086)",
    fill: "#cb3366"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.96286c434294980357d4b243583fefe7.svg";
export { ForwardRef as ReactComponent };